/**
 * The behaviour for a scroll the page starts from JavaScript (`scrollIntoView`,
 * `scrollTo`). A `behavior: "smooth"` passed there overrides the
 * `scroll-behavior: auto` that `app/globals.css` sets under reduced motion, so
 * every smooth scroll on a public page asks here first (`docs/03` §7,
 * `SITE-FIX01`).
 */
export function smoothScrollBehavior(): ScrollBehavior {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return "smooth";
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
}
